import React, { useState, useContext } from 'react';
import { Button, FormGroup, Label, Input, Card, CardHeader, CardBody, Table, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { AppContext } from '../AppContext';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import ReactPaginate from 'react-paginate';
import { useHistory } from 'react-router-dom';
import withRoleAccess from './withRoleAccess';

const TITLE = 'Reportes de Retroalimentación Estudiantil';
const MySwal = withReactContent(Swal);
const APIURL = process.env.REACT_APP_API_URL;

const ImpersonateUser = () => {

    const history = useHistory();
    document.title = TITLE + " - Impersonar usuario";

    const [searchCriteria, setSearchCriteria] = useState({
        nombres: '',
        apellidos: '',
        username: '',
        numeroidentificacion: '',
    });
    const [searchResults, setSearchResults] = useState([]);

    const [currentPage, setCurrentPage] = useState(0);
    const usersPerPage = 10;

    const { startImpersonation } = useContext(AppContext);
    const { currentUser } = useContext(AppContext);

    const handleSearchCriteriaChange = (e) => {
        const { name, value } = e.target;
        setSearchCriteria(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSearch = () => {
        const payload = {
            nombres: searchCriteria.nombres,
            apellidos: searchCriteria.apellidos,
            numeroidentificacion: searchCriteria.numeroidentificacion,
            username: searchCriteria.username
        };

        MySwal.showLoading();
        fetch(`${APIURL}/api/Account/impersonate-users`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
            .then((data) => {
                setSearchResults(data);
                setCurrentPage(0);
                MySwal.close();
            })
            .catch((error) => {
                console.error('Error al conseguir usuarios potenciales para impersonar:', error);
            });
    };

    const impersonate = async (emailAddress) => {

        const targetUsername = emailAddress.split('@')[0];
        try {
            MySwal.fire({
                title: 'Procesando petición...',
                allowOutsideClick: false,
                didOpen: () => {
                    MySwal.showLoading();
                }
            });

            const response = await fetch(`${APIURL}/api/Account/impersonate`, {
                method: 'POST',
                body: JSON.stringify({ TargetUserId: targetUsername  })
            });

            if (!response.ok) {
                throw new Error('Hubo un error en la red o en la petición.');
            }

            const r = await response.json();
            MySwal.fire({
                title: 'Éxito',
                text: 'Se registró su acción de actuar como un usuario',
                icon: 'success'
            }).then((result) => {
                if (result.isConfirmed) {
                    startImpersonation(r.token);
                    history.push('/');
                }
            });

        } catch (error) {
            MySwal.fire('Error', 'Hubo un error en el proceso de impersonar a un usuario.', 'error');
            console.error('Error al actuar como un usuario:', error);
        }
    };

    const indexOfLastUser = (currentPage + 1) * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    const paginatedUsers = searchResults.slice(indexOfFirstUser, indexOfLastUser);

    const handlePageClick = (data) => {
        const selectedPage = data.selected;
        setCurrentPage(selectedPage);
    };

    return (
        <Card>
            <CardHeader>Ver como un usuario</CardHeader>
            <CardBody>

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div className="mb-3">
                        <label htmlFor="nombres">Nombres</label>
                        <input
                            type="text"
                            className="form-control"
                            id="nombres"
                            name="nombres"
                            value={searchCriteria.nombres}
                            onChange={handleSearchCriteriaChange}
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="apellidos">Apellidos</label>
                        <input
                            type="text"
                            className="form-control"
                            id="apellidos"
                            name="apellidos"
                            value={searchCriteria.apellidos}
                            onChange={handleSearchCriteriaChange}
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="username">Usuario ESPOL</label>
                        <input
                            type="text"
                            className="form-control"
                            id="username"
                            name="username"
                            value={searchCriteria.username}
                            onChange={handleSearchCriteriaChange}
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="numeroidentificacion">Cédula</label>
                        <input
                            type="text"
                            className="form-control"
                            id="numeroidentificacion"
                            name="numeroidentificacion"
                            value={searchCriteria.numeroidentificacion}
                            onChange={handleSearchCriteriaChange}
                        />
                    </div>
                </div>

                <div className="d-flex pb-3">
                    <Button color="primary" onClick={handleSearch}>
                        Buscar
                    </Button>
                </div>

                <Table responsive={true} striped={true}>
                    <thead>
                        <tr>
                            <th className="text-center col-1" scope="col">Nombres</th>
                            <th className="text-center col-1" scope="col">Apellidos</th>
                            <th className="text-center col-1" scope="col">Correo</th>
                            <th className="text-center col-1" scope="col">Identificación</th>
                            <th className="col-1" scope="col">{' '}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedUsers.map((user, index) => (
                            <tr key={index}>
                                <td className="text-center">{user.nombres}</td>
                                <td className="text-center">{user.apellidos}</td>
                                <td className="text-center">{user.emailAddress}</td>
                                <td className="text-center">{user.numeroidentificacion}</td>
                                <td>
                                    {currentUser && !currentUser.isImpersonated && 
                                        <Link
                                            className="btn btn-success"
                                            to="#"
                                            onClick={() => impersonate(user.emailAddress)}
                                        >
                                            Ver como
                                        </Link>
                                    }
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                {searchResults.length > 10 && (
                    <ReactPaginate
                        previousLabel={"← Anterior"}
                        nextLabel={"Siguiente →"}
                        //breakLabel={'...'}
                        pageCount={Math.ceil(searchResults.length / usersPerPage)}
                        //marginPagesDisplayed={2}
                        //pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        //subContainerClassName={'pages pagination'}
                        activeClassName={'active'}
                        previousLinkClassName={"pagination__link"}
                        nextLinkClassName={"pagination__link"}
                        disabledClassName={"pagination__link--disabled"}
                        activeClassName={"pagination__link--active"}
                    />
                )}
            </CardBody>
        </Card>
    );
};

export default withRoleAccess(ImpersonateUser, ['ADMIN']);
